import InputTypes from '../../../enums/InputTypes';
import { arrayToDate, arrayToDateString } from '../../../utils/DateMixins';

export default class ViewrMapper {
    #mapper;
    constructor(mapper) {
        this.#mapper = mapper;
    }

    #getInputs(fields) {
        const inputs = [];
        for (let i = 0; i < fields.length; i++) {
            const field = fields[i];

            const tableNameUse = field?.showTable?.nameUse ?? field.nameUse;
            const nameUse = field?.table?.nameUse ?? tableNameUse;
            inputs.push({
                nameField: field?.name,
                nameUse: nameUse ?? field?.name,
                type: field?.type,
                export: field?.export,
                table: field?.table ?? { fromTo: field?.fromTo ?? null },
            });
        }
        return inputs;
    }

    format(value, input, isView = false) {
        let nValue = value;
        switch (input.type) {
            case InputTypes.DATE:
                if (Array.isArray(nValue)) {
                    nValue = isView ? arrayToDateString(nValue) : arrayToDate(nValue, true);
                }
                break;
            case InputTypes.DATETIME:
                if (Array.isArray(nValue)) {
                    nValue = arrayToDateString(nValue, true);
                }
                break;
            case InputTypes.ENTITY:
                nValue =
                    typeof nValue === 'object' && nValue?.descricao ? nValue?.descricao : nValue;
                break;
            case InputTypes.BOOLEAN:
                if (Array.isArray(input?.fromTo) || Array.isArray(input?.table?.fromTo)) {
                    const [ifTrue, ifFalse] = input?.fromTo ?? input.table.fromTo;
                    nValue = nValue ? ifTrue : ifFalse;
                }
                break;
            default:
                nValue = value;
                break;
        }
        return nValue;
    }

    async prepare(dados, config) {
        if (Array.isArray(dados)) {
            const fields = config
                .getInputs()
                .filter((el) => el?.showTable?.use || el?.showTable || el?.table?.use);
            const inputs = this.#getInputs(fields);
            return dados.map((item) => {
                for (let i = 0; i < inputs.length; i++) {
                    item[inputs[i].nameField] = eval(
                        `item.${inputs[i].nameUse}`.replaceAll('?.', '.').replaceAll('.', '?.')
                    );

                    if (item.hasOwnProperty(inputs[i].nameField)) {
                        item[inputs[i].nameField] = this.format(
                            item[inputs[i].nameField],
                            inputs[i],
                            true
                        );
                    }
                }
                return item;
            });
        }
        return dados;
    }
}
